export interface Program {
  id: string;
  name: string;
  shortDescription: string;
  description: string;
  features: string[];
  image: string;
}

export const programs: Program[] = [
  {
    id: 'private-training',
    name: 'Private Training 1 on 1',
    shortDescription: 'Personalized coaching tailored to your goals and skill level.',
    description: 'Experience one-on-one training with an international boxer. Every session is customized to your fitness level, boxing goals, and schedule. Whether you want to compete, get fit, or learn self-defense, private training accelerates your progress.',
    features: [
      'Custom workout plans',
      'Technique analysis and correction',
      'Flexible scheduling',
      'Nutrition guidance',
    ],
    image: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/3a394b46-4f23-441a-9ae0-613e9be79a65_ChatGPT-Image-May-4-2026-08_29_10-AM.png?v=2e9eba241e907b4a0c571ad49d7a594d',
  },
  {
    id: 'group-training',
    name: 'Group Training',
    shortDescription: 'Train alongside others and push each other to new limits.',
    description: 'High-energy group sessions that combine cardio, strength, and boxing technique. Train alongside like-minded individuals and feed off the group energy. Suitable for all fitness levels with modifications available.',
    features: [
      'Partner drills and sparring',
      'High-intensity interval training',
      'Team motivation and accountability',
      'All fitness levels welcome',
    ],
    image: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/dd33fd73-82ac-4422-b39e-9380383aae1b_WhatsApp-Image-2026-05-04-at-8.11.56-AM.jpeg?v=2a9b7445319faf80df444404515e5e2d',
  },
  {
    id: 'youth-program',
    name: 'Youth Program',
    shortDescription: 'Building discipline, confidence, and fitness for young athletes.',
    description: 'A structured program designed for young boxers aged 8-17. We focus on building discipline, respect, self-confidence, and athletic fundamentals in a safe and supportive environment. The program instills life skills beyond boxing.',
    features: [
      'Age-appropriate training',
      'Focus on discipline and respect',
      'Anti-bullying confidence building',
      'Safe and supervised environment',
    ],
    image: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/8ef6c6ed-003e-4403-9e3b-4f39c8380132_ChatGPT-Image-May-4-2026-08_26_09-AM.png?v=ed0bbac6fcd9f078ffbec50626d2e963',
  },
  {
    id: 'home-training',
    name: 'Home Training',
    shortDescription: 'Bring the boxing workout to your home with guided sessions.',
    description: 'Cannot make it to the gym? Get professional boxing training at your doorstep. Our coach comes to you with all necessary equipment, providing a complete boxing workout in the comfort of your own home or outdoor space.',
    features: [
      'Coach visits your location',
      'All equipment provided',
      'Flexible time slots',
      'Personalized home workout plans',
    ],
    image: 'https://readdy.ai/api/search-image?query=Professional%20boxing%20coach%20conducting%20a%20personal%20home%20training%20session%2C%20athlete%20shadow%20boxing%20with%20gloves%20in%20a%20home%20gym%20setup%2C%20dramatic%20dark%20cinematic%20lighting%20with%20red%20rim%20light%20on%20black%20background%2C%20professional%20sports%20photography%2C%20high%20contrast%2C%20premium%20fitness%20lifestyle%2C%20modern%20training%20at%20home&width=800&height=600&seq=program-home-2&orientation=landscape',
  },
];
